// components/StudentForm/StudentDetails.jsx
import React from 'react';
import DepartmentSkillsSelector from '../../Placementdb/DepartmentSkillsSelector';


const StudentDetails = ({
    formData,
    onDepartmentChange,
    onSkillsChange,
    showToast,
    onFormDataChange,
    locationsData = {},
    trainers = [],

}) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        onFormDataChange(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleLocationChange = (e) => {
        const selectedLocation = e.target.value;
        onFormDataChange(prev => ({
            ...prev,
            location: selectedLocation,
            branch: '',
            staffAssigned: '',
            mentorName: ''
        }));
    };

    const handleStaffChange = (e) => {
        const { name, value } = e.target;

        onFormDataChange(prev => {
            const updatedState = {
                ...prev,
                [name]: value,
            };

            // Auto-fill mentor and staff details when staff is assigned
            if (name === "staffAssigned") {
                const selectedStaff = trainers.find(t => t.emp_name === value);
                if (selectedStaff) {
                    updatedState.mentorName = selectedStaff.emp_name;
                    updatedState.staffAssignedId = selectedStaff.emp_id;
                    updatedState.mentorId = selectedStaff.emp_id;
                    updatedState.mentorNumber = selectedStaff.contact_num;
                } else {
                    updatedState.mentorName = "";
                    updatedState.staffAssignedId = "";
                    updatedState.mentorId = "";
                    updatedState.mentorNumber = "";
                }
            }

            return updatedState;
        });
    };

    return (
        <div className="form-section">

            <div className="section-content">
                {/* Name */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">
                            Name <span className="mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={formData.studentName || ''}
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>
                    <div className="form-group">
                        <label className="label">Ready for Placement</label>
                        <input
                            type="text"
                            name="readyForPlacement"
                            value={formData.readyForPlacement || 'No'}
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>

                </div>
                {/* Contact & Email */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">
                            Contact Number <span className="mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            name="contactNo"
                            value={formData.contactNo || ''}
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}

                        />
                    </div>

                    <div className="form-group">
                        <label className="label">Email<span className="mandatory">*</span></label>
                        <input
                            type="email"
                            name="email"
                            readOnly
                            value={formData.email || ''}
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>
                </div>


                {/* Student Progress Status */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">Ready For Placement Date</label>
                        <input
                            type="date"
                            name="readyForPlacementDate"
                            value={formData.readyForPlacementDate || ""}
                            readOnly
                            className="input"
                            style={{
                                backgroundColor: "#f5f5f5",
                                cursor: "not-allowed"
                            }}
                        />
                    </div>

                    <div className="form-group">
                        <label className="label">Created Date</label>
                        <input
                            type="text"
                            value={
                                formData.createdAt
                                    ? new Date(formData.createdAt).toLocaleDateString("en-GB", {
                                        timeZone: "Asia/Kolkata"
                                    })
                                    : ""
                            }
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>
                </div>
                {/* Location & Branch */}
                <div className="form-row">
                    <div className="form-group">
                        <label className="label"> Preferred Job Location</label>
                        <input
                            value={formData.location || ''}
                            readonly
                            className="input select"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>


                    <div className="form-group">
                        <label className="label">
                            Branch <span className="mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            name="branch"
                            value={formData.branch || ''}
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>
                </div>

                {/* Staff Assigned & Mentor */}

                    <div className="form-group full-width">
                        <DepartmentSkillsSelector
                            department={formData.Department}
                            skillsKnown={formData.skillsKnown}
                            onDepartmentChange={onDepartmentChange}
                            onSkillsChange={onSkillsChange}
                            showToast={showToast}
                            departmentRequired={true}
                            skillsRequired={false}
                            layout="horizontal"
                            readOnly={true}
                        />
                    </div>
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">
                            Course Completion Status <span className="mandatory">*</span>
                        </label>
                        <input
                            name="studentProgressStatus"
                            value={formData.studentProgressStatus || ''}
                            readOnly
                            className="input select"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}

                        />

                    </div>
                    <div className="form-group">
                        <label className="label">
                            Gender <span className="mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={formData.gender || ''}
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group">
                        <label className="label">
                            Date of Birth <span className="mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={formData.dob || ''}
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>
                    <div className="form-group">
                        <label className="label">
                            Address <span className="mandatory">*</span>
                        </label>
                        <input
                            type="text"
                            name="name"
                            value={formData.address || ''}
                            readOnly
                            className="input"
                            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentDetails;